import { sanitizeSentryPayload } from 'app/lib/sentry-sanitize';
import { useEffect } from 'react';
import { isMobileNative } from 'app/utils/web-helpers';
import * as SentryMobile from '@sentry/react-native';
import * as SentryWeb from '@sentry/react';
import { env } from 'app/lib/env';

let initialized = false;

export const initializeSentry = () => {
  if (initialized || env.APP_ENV === 'local') return;
  initialized = true;

  const config = {
    dsn: 'https://001e9500a37a3439625bc546602e80c5@o4510047483658240.ingest.us.sentry.io/4510047486083072',
    environment: env.APP_ENV,
    sendDefaultPii: false,
    beforeBreadcrumb: sanitizeSentryPayload,
    beforeSend: sanitizeSentryPayload,
    beforeSendTransaction: sanitizeSentryPayload,
    beforeSendLog: sanitizeSentryPayload,
    tracesSampleRate: 0.05,
  };

  if (isMobileNative) {
    SentryMobile.init(config);
  } else {
    SentryWeb.init(config);
  }
};

export const useSentry = () => {
  useEffect(initializeSentry, []);
};
